import * as d3 from 'd3';
import * as d3Scale from 'd3-scale';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { BarChartMargin } from '../barChart/type';

export type AxisItem = {
  label: string;
  value: number;
  tooltipText?: string;
  tooltipSubText?: string;
};

interface UseAxisParams {
  data: Array<AxisItem>;
  width: number;
  height: number;
  margin: BarChartMargin;
}

export const useAxis = ({ data, width, height, margin }: UseAxisParams) => {
  const graphWidth = useMemo(() => width - margin.left * 2 - margin.right, [width, margin.left, margin.right]);
  const graphHeight = useMemo(() => height - margin.top - margin.bottom * 2, [height, margin.top, margin.bottom]);

  const scales = useMemo(() => {
    const x = d3Scale
      .scaleBand()
      .domain(d3.map(data, (d) => moment(d.label).format('MM-DD')))
      .range([0, graphWidth]);

    const yDomain = [0, d3.max(data, (d) => d.value) || 0];
    const y = d3Scale.scaleLinear().domain(yDomain).range([graphHeight, 0]).nice();

    return { x, y };
  }, [data, graphHeight, graphWidth]);

  return {
    graphWidth,
    graphHeight,
    xScale: scales.x,
    yScale: scales.y
  };
};
